import globalStore from '$$globalStore';

export default function (instance) {
  instance.expandCollapseAll = type => {
    const open = type === 'expand' ? 1 : 0;
    const allTasks = instance.serialize().data;
    const taskChanges = [];
    const tasksMap = globalStore.getters['tasksModel/tasksByIds'];

    instance.batchUpdate(() => {
      allTasks.forEach(task => {
        if (task.type === 'project' && task.parent) {
          const ganttTask = instance.getTask(task.id);
          const updatedTask = {
            ...ganttTask,
            $open: open,
            open,
          };

          instance.silent(() => {
            instance.updateTask(task.id, updatedTask);
          });

          if (tasksMap[task.id]) {
            taskChanges.push({ id: task.id, open });
          }
        }
      });
    });

    const multiviewId = instance.config.multiview ? +instance.config.multiview_id : null;

    instance.callEvent('onExpandCollapseAll', [taskChanges, multiviewId]);
  };
}
